import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'

import mobileImg from 'assets/images/homepage/app-mobile-preview-angled.webp'
import underline from 'assets/images/homepage/text_decorators/text-underline.svg'
import { MLPDownloadAppCTA } from 'components/marketing_landing_page'

export const MLPDownloadAppCard = () => {
  const { colors, mediaQueries } = useTheme()

  return (
    <FlexBox
      className={css`
        margin: 60px auto 0;
        padding: 36px 16px 0;
        background-color: ${colors.uiPinkLight};
        border-radius: 28px;
        overflow: hidden;
        max-width: 736px;
      `}
      flexDirection="column"
      alignItems="center"
    >
      <Text
        type="header"
        color={colors.uiGraphite}
        align="center"
        custom={{
          fontSize: '14.286vw',
          lineHeight: '14.286vw',
          letterSpacing: '-3px',
          [mediaQueries.mobileL]: {
            fontSize: '56px',
            lineHeight: '56px',
          },
        }}
      >
        Where readers
      </Text>
      <Text
        className={css`
          margin-top: -12px;
          position: relative;
        `}
        type="script"
        color={colors.uiWhite}
        align="center"
        custom={{
          fontSize: '44px',
          lineHeight: '44px',
          letterSpacing: '-0.5px',
        }}
      >
        discuss books
        <img
          className={css`
            width: 50%;
            position: absolute;
            inset: auto auto -4px 50%;
            transform: translateX(-50%);
          `}
          src={underline}
          alt="text underline"
        />
      </Text>
      <Text
        className={css`
          margin: 16px 0 16px;
          max-width: 222px;
        `}
        type="body"
        sizing="M"
        align="center"
        color={colors.uiGraphite}
      >
        Download the free app to get started today!
      </Text>
      <MLPDownloadAppCTA
        className={css`
          max-width: 148px;
          width: 100%;
        `}
        text="Download"
      />
      <img
        className={css`
          margin-top: 20px;
          display: block;
          width: 100%;
          max-width: 344px;
        `}
        src={mobileImg}
        alt="fable app mobile demo"
      />
    </FlexBox>
  )
}
